import { IconButton, Modal, Stack } from "@mui/material";
import { ContentModal } from "../../Surfaces/ContentModal/ContentModal";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import NoteData from "./components/NoteData/NoteData";
import Ticket from "./components/Ticket/Ticket";
import Invoice from "./components/Invoice/Invoice";
import { useEffect, useState } from "react";
import ConsumptionDoubts from "./components/ConsumptionDoubts/ConsumptionDoubts";

export default function ModalFinance({ open, onClose, ticket }) {
  const [page, setPage] = useState("noteData");

  useEffect(() => {
    setPage("noteData");
  }, [open]);

  if (!ticket) return null;

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus={true}>
      <ContentModal
        minWidth={"883px"}
        style={{ width: "auto" }}
        borderRadius={"16px"}
      >
        <Stack p={"32px"}>
          <Stack
            direction={"row"}
            justifyContent={page !== "noteData" ? "space-between" : "flex-end"}
            alignItems={"center"}
            mb={"24px"}
          >
            {page !== "noteData" && (
              <IconButton onClick={() => setPage("noteData")} sx={{ p: 0 }}>
                <ArrowBackIcon
                  sx={{
                    color: "#053462",
                    fontSize: "31px",
                  }}
                />
              </IconButton>
            )}

            <IconButton onClick={onClose}>
              <CloseIcon
                sx={{
                  color: "#053462",
                  fontSize: "31px",
                }}
              />
            </IconButton>
          </Stack>
          {page === "noteData" && (
            <NoteData
              ticket={ticket}
              onClickInvoice={() => setPage("invoice")}
              onClickTicket={() => setPage("ticket")}
              onClickConsumptionDoubts={() => setPage("ConsumptionDoubts")}
            />
          )}
          {page === "ticket" && <Ticket ticket={ticket} />}
          {page === "invoice" && <Invoice invoice={ticket} />}
          {page === "ConsumptionDoubts" && (
            <ConsumptionDoubts invoice={ticket} />
          )}
        </Stack>
      </ContentModal>
    </Modal>
  );
}
